package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.ConversationDetailsDomain

@Serializable
data class ConversionDetailsDto(
    @SerialName("exchange_rate") val exchangeRate: Float,
    @SerialName("formula") val formula: String,
)

fun ConversionDetailsDto.toDomain() = ConversationDetailsDomain(
    exchangeRate = exchangeRate,
    formula = formula
)